import './Footer.module.scss';

const Footer = () => {
    return (
        <div style={{fontFamily: "Rubik", opacity: 0.5, paddingLeft: "40px", paddingRight: "40px", textAlign: "center"}}>
            <p style={{fontSize: "12px", lineHeight: "24px"}}>
                <a href={process.env.REACT_APP_PRIVACY_POLICY_URL} target="_blank" rel="noreferrer">Privacy Policy</a>&nbsp;|&nbsp;
                <a href={process.env.REACT_APP_TERMS_OF_SERVICE_URL} target="_blank" rel="noreferrer">Terms & Conditions</a>&nbsp;|&nbsp;
                <a href={process.env.REACT_APP_SWEEPSTAKES_RULES_URL} target="_blank" rel="noreferrer">At-Home Game Rules</a>&nbsp;|&nbsp;
                <a href={process.env.REACT_APP_30K_GIVEAWAY_RULES_URL} target="_blank" rel="noreferrer" >$30K Giveaway Rules</a><br/>
                    Powered by <a href="https://www.actv8me.com" target="_blank" rel="noreferrer">ACTV8me</a>
            </p>            
        </div>
    )
}


export default Footer;